class VwProductSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selectedOptionText = this.querySelector("#dynamic-option-value");
    this.videos = this.querySelectorAll("#vw-video");
    this.variants = this.querySelectorAll("#vw-custom-slider-variant");
    this.buttons = this.querySelectorAll("#vw-custom-slider-atc");
    this.isDeepLink = this.hasAttribute("data-enable-deep-link-logic");

    this.variants.forEach((variant) => {
      variant.addEventListener("click", () => {
        const { optionName } = variant.dataset;
        const { variantId } = variant.dataset;

        const color = optionName.substring(
          optionName.indexOf("(") + 1,
          optionName.indexOf(")")
        );

        this.selectedOptionText.innerHTML = `<strong>${optionName.replace(
          "(" + color + ")",
          ""
        )}</strong> is a ${color}`;

        this.variants.forEach((v) => {
          v.classList.remove("is-active");
        });
        variant.classList.add("is-active");

        this.activeVideo =
          this.querySelector(`#vw-video[data-target="${variantId}"]`) || null;

        this.videos.forEach((video) => video.classList.remove("is-active"));
        this.activeVideo && this.activeVideo.classList.add("is-active");
        window.dispatchEvent(new Event('scroll'));

        if (!this.isDeepLink) return;

        this.buttons.forEach((button) => {
          const currentHref = button.href;
          const newHref = currentHref.replace(
            /variant=[0-9]*/,
            `variant=${variantId}`
          );

          button.href = newHref;
        });
      });
    });
  }
}

window.customElements.define("vw-product-slider", VwProductSlider);
